module.exports = __webpack_public_path__ + "static/gh-esg-statement-6e96c23e2e74189a3d61498703e3c9ba.pdf";